import { ApexAnnotations, ApexAxisChartSeries, ApexFill, ApexStroke } from 'ngx-apexcharts';
import { BenchmarkDiagramSeries } from '../../benchmarks/benchmarks-model';
import { DriverType } from '../driver-types/driver-type';
import { DimensionName, ExplodableDimension } from './dimension-name';
import { Subtotal  }  from './subtotal';
import { LoadingStatus } from '../../loading-status';
import { WaterfallItem2 } from 'src/app/cards/waterfall-item';

export class CardLocation {
    public tabId: number;
    public cardIndex: number;
}

export class ApexChartData {
    public series: ApexAxisChartSeries;
    public annotations: ApexAnnotations;
    public fill: ApexFill;
    public stroke: ApexStroke;
    colors: string[];
}

export class AltCardView {
    public formCompOldVal: number;
    public formCompNewVal: number;
    public formCompPerc: number;
    public formCompAbsPerc: number;
    //lost or new for a Lost card, a New card or a card of the New/Lost source whose rows are in the old period only or in the new one only: N/A for the
    //other one, and for a card of the New/Lost source Lost or New instead of the %
    public newLostType: DriverType | null;
    public outcomeOldVal: number;
    public outcomeNewVal: number;
    public diagramSeries: BenchmarkDiagramSeries[];
    public apexChartData: ApexChartData | undefined;
}

export enum FcstWalkCardType {
    Precedent,
    Set,
    Group,
}

export class Card {
    public cardType: FcstWalkCardType;
    public allDimensions: string[];
    public driverType : DriverType;
    public formulaComponentIndex: number;

    public driverId: any;
    public driverName: string;
    public seqDriverValue: number;
    public seqPercentValue: number;
    public absDriverValue: number;
    public absPercentValue: number;
    public dimensions: DimensionName[];

    get visibleDimensions(): DimensionName[] {
        return this.dimensions.slice(0, 4);
    }
    get hiddenDimensions(): DimensionName[] {
        return this.dimensions.slice(4);
    }

    public isLocked: boolean;
    public subtotal: Subtotal | undefined;

    public cardLocation: CardLocation;

    public tabUId?: string;     //client-side cache only

    //waterfall chart vals:
    public seqChartColorSeqMode: string;
    public seqChartColorAbsMode: string;
    public absChartColor: string;
    public seqChartColorSeqModeWithOutOfScope: string;
    public seqChartColorAbsModeWithOutOfScope: string;

    public absChartColorWithOutOfScope: string;

    public confidenceColor: string;
    public confidenceUnavailable: boolean;

    public addOutOfScopeCardToParentAvailable: boolean;

    //alt card view:
    public altViewSeq: AltCardView;
    public altViewTot: AltCardView;
    public formCompWeightSettingName: string;
    public driverNameForAltView: string;

    public selectedDiagram: BenchmarkDiagramSeries;

    public isExplodable: boolean = true;
    public explodableBy: ExplodableDimension[];
    public recommendedBreakdownLoadingStatus: LoadingStatus = LoadingStatus.NotStarted;
    public cardHovered: boolean;
    public menuOpened: boolean;

    public showInlineButtons: boolean;

    //fancy pipe contexts:    
    public formCompCtx: any;
    public outcomeCtx: any;
    public diagramMinMaxCtx: any;
    public diagramValsCtx: any;

    public isMultiSelected: boolean;

    public waterfallItem: WaterfallItem2;

    //for fcst walk
    public cardPath: number[];

    public isHighlighted: boolean;
}
